import 'element-ui/lib/theme-chalk/index.css';
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store' //引入store
import Element from 'element-ui';
import directives from '../src/api/utils'
import less from 'less'
import '!style-loader!css-loader!less-loader!./style/common.less';
import '../src/style/common.css';
import 'normalize.css'
import moment from 'moment'
//引用富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
//引入富文本css
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'


Vue.prototype.$moment = moment;
Vue.use(VueQuillEditor, /* { default global options } */)

Vue.use(less)
Vue.use(directives)

Vue.config.productionTip = false


Vue.use(Element);


import { Message } from 'element-ui'



router.beforeEach(function(to, from, next) {
    let v = this;
    let uri = to.path;
    if (uri.indexOf("login") == -1 && uri.indexOf("manage") != -1) {
        if (uri == "/manage") {
            uri = "/manage/courseManage"
        }
        let userInfo = sessionStorage.getItem("userInfo");
        if (!userInfo) {
            Message.error("未登录");
            next("/managelogin")
            return;
        }
        let perStr = sessionStorage.getItem("permissions");
        if (!perStr || perStr == "") {
            Message.error("无权限");
            next(from.path)
            return;
        }
        let list = JSON.parse(perStr);
        let auth = false;
        list.forEach((i) => {
            if (uri.indexOf(i.uri) != -1) {
                auth = true;
            }
        });
        if (!auth) {
            Message.error("无权限");
            next(from.path)
        }
    }

    next()
})


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store, //使用store
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js